export default "__VITE_ASSET__6a1f42b4__"